import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialDailyEfficiencySummaryState from './daily-efficiency-summary-initial-state';
import { DailyEfficiencySummary } from '../models/dailyEfficiencySummary.model';
import { Dayjs } from 'dayjs';

const dailyEfficiencySummarySlice = createSlice({
    name: 'dailyEfficiencySummarySlice',
    initialState: initialDailyEfficiencySummaryState,
    reducers: {
        setChartData(state, { payload }: PayloadAction<DailyEfficiencySummary[]>) {
            state.chartData = payload;
        },
        setForklifts(state, { payload }: PayloadAction<string[]>) {
            state.forklifts = payload;
        },
        setOrganizations(state, { payload }: PayloadAction<string[]>) {
            state.organizations = payload;
        },
        setCompanies(state, { payload }: PayloadAction<string[]>) {
            state.companies = payload;
        },
        setDepartments(state, { payload }: PayloadAction<string[]>) {
            state.departments = payload;
        },
        setModels(state, { payload }: PayloadAction<string[]>) {
            state.models = payload;
        },
        setActivities(state, { payload }: PayloadAction<string[]>) {
            state.activities = payload;
        },
        setTags(state, { payload }: PayloadAction<string[]>) {
            state.tags = payload;
        },
        setCreateDate(state, { payload }: PayloadAction<string>) {
            state.dates.startDate = payload;
        },
        setEndDate(state, { payload }: PayloadAction<string>) {
            state.dates.endDate = payload;
        },
        setShowFilters(state, { payload }: PayloadAction<boolean>) {
            state.showFilters = payload;
        },
        setStartDateDayJS(state, { payload }: PayloadAction<Dayjs>) {
            state.startDate = payload;
        },
        setEndDateDayJS(state, { payload }: PayloadAction<Dayjs>) {
            state.endDate = payload;
        }
    }
});

export const {
    setChartData,
    setForklifts,
    setOrganizations,
    setCompanies,
    setDepartments,
    setModels,
    setActivities,
    setTags,
    setCreateDate,
    setEndDate,
    setShowFilters,
    setStartDateDayJS,
    setEndDateDayJS
} = dailyEfficiencySummarySlice.actions;

export default dailyEfficiencySummarySlice.reducer;
